<!-- Profiles Section starts here -->
<div [ngClass]="isOverTheAirUpdatesEnabled ? 'profile_tab_wrapper' : 'content__wrapper'" id="profileSectionContent">
  <div *ngIf="!tabIndex" class="card existing_profiles"
    [ngClass]="(isProfileDataEmpty && !profileDataSearch) ? 'existing_profiles_show': 'existing_profiles_hide'" id="cardExistingProfiles">
    <div class="card-header" id="existingProfileCardHeader">
      <div class="title" id="existingProfileTitle">{{exisitingProfiles}}</div>
    </div>
    <div *ngIf="!profileDataSearch" class="pl-0 pr-0 card-body" id="profileCardBody">
      <div id="profileDesc"><span i18n="@@profile.header.noprofile-description">You do not have any custom profiles to
          view.</span></div>
      <div class="option_row" id="profileOptionRow">
        <div class="profile_type" id="profileType">
          <div class="ml-0 mt-0 help_text" id="profileHelpTxt"><span
              i18n="@@profile.header.if-you-don't-need-customization-for-non-custom-package">If you don’t need
              customization, please click on the button below to download a Non-custom IPOS Package.</span></div>
          <button type="button" class="btn btn-primary btn-lg gtmProfilesDownloadStd mt-2"
            (click)="navigateToStandardIPOS()">
            {{downloadIPOS}}
          </button>
        </div>
        <div class="inline_separator" id="profileInlineSeparator"></div>
        <div class="profile_type" id="profileTypeCustom">
          <div class="mt-0" id="nonProfileBtnDesc"><span i18n="@@profile.header.noprofile-button-description">If you
              want to customize, please click on the below button to create a Custom Profile.</span></div>
          <button type="button" class="btn btn-primary btn-lg gtmProfilesCreateProfile mt-2"
            (click)="showCreateProfile()">
            {{createProfile}}
          </button>
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="profileDataSearch || !searchMainstreamResult" id="dataProfileSearchFound">
      <span i18n="@@active-users.expand.no-records-found">No Records Found</span>
    </div>
  </div>

  <div class="card existing_profiles"
    [ngClass]="(!isProfileDataEmpty || tabIndex || profileDataSearch) ? 'existing_profiles_show': 'existing_profiles_hide'"
    id="existingProfilesHide">
    <div class="card-header border_bottom" id="existingCardHeader">
      <span>
        <h2 [ngClass]="tabIndex ? 'mb-0':''" [innerHTML]="exisitingProfiles"></h2>
        <div class="page-footer-label profile-sub-title mb-2" *ngIf="tabIndex">Only Mainstream Windows profiles can be
          updated</div>
        <span class="page-footer-label" *ngIf="profileData?.length" i18n="@@profile.header.page-count">Showing
          <strong>{{ showFrom }} - {{ showTo }}</strong> of
          <strong>{{ paginationCount }} Profiles</strong></span>
      </span>
      <!-- For search button-->
      <div class="search_group" id="searchProfileGrp">
        <div class="input-group" id="inputProfileGrp">
          <input #searchValue [(ngModel)]="searchData" (keyup.enter)="searchReportOnEnter(searchData)" type="input"
            class="form-control" placeholder="{{searchPlaceHolderText}}" maxlength="75" (ngModelChange)="onProfileSearchInput($event)" />
          <img alt="close" *ngIf="searchData?.length" (click)="clearProfileSearch()" class="search-clear-icon">
        </div>
        <button type="button" (click)="searchProfilesReport(searchData)" class="btn btn-primary search_btn">
          <img class="searchicon" alt="search" />
        </button>
      </div>
      <span *ngIf="(!tabIndex)">
        <button type="button" id="createProfile" class="btn btn-primary btn-lg left_icon_btn gtmProfileCreateProfile"
          (click)="showCreateProfile()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span [innerHTML]="createProfile"></span>

        </button>
      </span>
      <div class="alert-info-grp">
        <span *ngIf="tabIndex" class="alert alert-info profile-sub-title"><em class="caution_img"></em>&nbsp;<span>{{updateIPOSDisplayMsg}}</span></span>    
        <span *ngIf="tabIndex && showIposLiteMsg" class="alert alert-info profile-sub-title"><em class="caution_img"></em>&nbsp;<span>{{updateIPOSLiteDisplayMsg}}</span></span>      
      </div>
    </div>
    <!-- Filter Data  -->
    <div *ngIf="tabIndex" class="filter_options" id="filtrrOptionActiveUsr">
      <div class="form-inline" id="frmInline">
          <span id="filterfont" class="mr-4 filter-label" i18n="@@active-users.filter-options.filters">Filters</span>        
          <div id="ngbdropDown" ngbDropdown class="btn-group">
            <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
              aria-haspopup="true" aria-expanded="false">
              <span *ngIf="selectedValue == 'custom'" i18n="@@active-users.retail.retail-hq">Custom Packages</span>
              <span *ngIf="selectedValue != 'custom'" i18n="@@active-users.retail.non-custom-packages">Non-Custom Packages</span>
            </button>
            <div id="ngbDropdownMenu" ngbDropdownMenu aria-labelledby="sizeDropDown">
              <ng-container *ngFor="let data of filterType">
                <a ngbDropdownItem (click)="onFilter(data)" *ngIf="selectedValue!=data">
                  <span *ngIf="data == 'custom'" i18n="@@active-users.retail.retail-hq">Custom Packages</span>
                  <span *ngIf="data != 'custom'" i18n="@@active-users.retail.non-custom-packages">Non-Custom Packages</span>
                </a>
              </ng-container>
            </div>
          </div>          
      </div>
    </div>
    <hr [ngClass]="tabIndex ? 'mt-2': 'mt-0'" class="mb-0"/>
    <div *ngIf="profileData?.length" class="card-body table-responsive-md profile-listing-div" id="profileListingDiv">
      <table *ngIf="!tabIndex" id="existingProfilesTable" class="table table-borderless" aria-describedby="profile">
        <colgroup>
          <col span="4" />
          <col span="3" id="last_3_cols" />
        </colgroup>
        <thead>
          <tr *ngIf="profileData?.length">
            <th class="col_width" scope="col" (click)="sort('profile-name')">
              <span i18n="@@profile.table.profile">Profile</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="col_width_updated" scope="col" (click)="sort('lastUpdatedTime')">
              <span>{{updateLastUpdate}}</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="os_Horizontal" scope="col" *ngIf="userRole !== 'srtUser'" (click)="sort('operatingSystem')">
              <span i18n="@@profile.table.os">Operating System</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="lang_width" scope="col" data-name="languages" (click)="sort('languages')">
              <span i18n="@@profile.table.languages">Languages</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="col_statuswidth" scope="col" data-name="IposPackage">
              <span i18n="@@profile.table.package">{{userRole === 'srtUser' ? 'PC Finder Package' : 'IPOS Package'
                }}</span>
            </th>
            <th scope="col" id="actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let new of profileData; let i = index">
            <td><a (click)="editProfile(new.profileId,new)"
                [ngClass]="!(new.pbStarted || new.packageStatus === globalConst.PND_LWR) ? 'mouse_poniter':'default_pointer'">{{
                new.profileName }}</a></td>
            <td>{{ new.updatedDate | dateFormat: 'changeToLocalTimeZone'}}</td>
            <td *ngIf="userRole !== 'srtUser'"><em
                [ngClass]="{ 'windows': checkOSType(new.operatingSystem), 'linux': new.operatingSystem === 'LINUX' || new.operatingSystem === 'Linux/Devices with no operating systems', 'chromeOS': new.operatingSystem === 'CHROME' }"></em>
              {{getOSName(new?.operatingSystem)}}</td>
            <td>{{getLanguageNames(new?.languages)}}</td>
            <td
              [ngClass]="(new.packageStatus === globalConst.CMP_LWR) ? 'existing_profiles_show': 'existing_profiles_hide'"
              (click)='onDownloadPackage(new)'><em class="download_icon gtmProfileDownload"></em><span
                class="download-icon-label" [innerHTML]="download"></span></td>
            <td
              [ngClass]="([globalConst.DFT_LWR, globalConst.FLD_LWR].indexOf(new.packageStatus) > -1 && !new.pbStarted) ? 'existing_profiles_show': 'existing_profiles_hide'"
              (click)="onGeneratePackage(new,i)"><em class="generate_package_icon"></em><span
                class="generate-icon-label" [innerHTML]="generate"></span></td>
            <td
              [ngClass]="(new.packageStatus === globalConst.PND_LWR || new.pbStarted) ? 'existing_profiles_show': 'existing_profiles_hide'">
              <div class="pb-widget" [ngStyle]="{'background':getProgressbarBgColor(new.packageGenerationProgress)}">
                <div class="pb-values">{{new.packageGenerationProgress}}%</div>
              </div><span class="pb-text" [innerHTML]="generating"></span>
            </td>
            <td class="action_cell" *ngIf="checkProfileLite(new)">
              <div class="options_popup" *ngIf="!(new.pbStarted || new.packageStatus === globalConst.PND_LWR)"
                id="optionsPopup">
                <div class="option_type duplicate left_icon_btn gtmProfileDuplicate" *ngIf="!checkifCreator(new)"
                  (click)="openDuplicate(new.profileName,new.profileId)" placement="top" ngbTooltip={{duplicate}}
                  id="gtmProfileDuplicate">
                  <img alt="duplicate" />
                </div>
                <div class="option_type vector left_icon_btn gtmProfileEdit" *ngIf="!checkifCreator(new)" (click)="editProfile(new.profileId)"
                  placement="top" ngbTooltip={{edit}} id="gtmProfileEdit">
                  <img alt="edit" />
                </div>
                <div class="option_type delete left_icon_btn gtmProfileDelete" (click)="openDelete(new)" placement="top"
                  ngbTooltip={{deleteTooltipLabel}} id="gtmProfileDelete">
                  <img alt="delete" />
                </div>
              </div>
            </td>
          </tr>
          <!-- TODO the below code is part of old design now handling via new design-->
          <!-- <tr *ngIf="!profileData.length">
            <td class="profile_Record" [innerHTML]="noRecordFound"></td>
          </tr> -->
        </tbody>
      </table>
      <table *ngIf="tabIndex" id="existingProfilesTable" class="table table-borderless" aria-describedby="profile">
        <colgroup>
          <col span="4" />
          <col span="3" id="last_3_cols" />
        </colgroup>
        <thead>
          <tr *ngIf="profileData?.length">
            <th class="col_width" scope="col" (click)="sort('profile-name')">
              <span i18n="@@profile.table.profile">Profile</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th *ngIf="selectedValue == 'standard'" scope="col"></th>
            <th *ngIf="selectedValue != 'standard'" class="col_width_updated" scope="col" (click)="sort('contentType')">
              <span i18n="@@profile.table.content-type">Content Type</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th *ngIf="selectedValue != 'standard'" class="os_Horizontal" scope="col" (click)="sort('operatingSystem')">
              <span i18n="@@profile.table.os">Operating System</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th *ngIf="selectedValue == 'standard'" class="os_Horizontal" scope="col" [iposcenSort]="profileData"
              data-order="desc" data-name="languageCode">
              <span i18n="@@profile.table.languages">Language</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="lang_width" scope="col" [iposcenSort]="profileData" data-order="desc" data-name="deviceCount"
              (click)="selectedValue != 'standard'?sort('deviceCount'):true">
              <span i18n="@@profile.table.no-of-devices">No. of Devices</span> &nbsp; <em class="sort_filter"></em>
            </th>
            <th class="col_statuswidth" scope="col">
              <span i18n="@@profile.table.ipospackage"></span>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="(selectedValue == 'standard' && !isProfileSearch) || (selectedValue == 'standard' && searchMainstreamResult && isProfileSearch)">
          <tr *ngFor="let new of profileData | slice: (page-1) * tableSize : page * tableSize" class="row_hover">
            <td colspan="2"><a class="default_pointer" [innerHTML]="(new?.standardPack === 'iposlite' ? iposliteText : mainstreamText)"></a></td>
            <td> {{new?.languageCode}}</td>
            <td> {{ new?.deviceCount }}</td>
            <td>
              <div *ngIf=" new?.deviceCount > 0" style="width: max-content;">
                <a (click)="viewDevices(new)"
                  [ngClass]="!(new?.packageStatus === 'pending')?'mouse_poniter':'default_pointer'"><em
                    class="send_Icon_img"></em>&nbsp;&nbsp;{{viewDevice}}</a>
              </div>
              <div *ngIf=" new?.deviceCount == 0" [ngbPopover]="popContent2" triggers="mouseenter:mouseleave"
                style="width: max-content;">
                <a class="btn-disabled" disabled="disabled"
                  [ngClass]="!(new?.packageStatus === 'pending')?'mouse_poniter':'default_pointer'"><em
                    class="send_icon_disabled_img"></em>&nbsp;&nbsp;{{viewDevice}}</a>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="selectedValue != 'standard'">
          <tr *ngFor="let new of profileData" class="row_hover">
            <td><a class="default_pointer">{{ new?.profileName }}</a></td>
            <td> {{ new?.contentTypes }}</td>
            <td>
              <em
                [ngClass]="{ 'windows': new?.operatingSystem === 'Windows' || new?.operatingSystem === 'Windows 10' || new?.operatingSystem === 'WINDOWS' || new?.operatingSystem === 'UWP for Windows in S Mode', 'linux': new?.operatingSystem === 'Linux' || new?.operatingSystem === 'Linux/Devices with no operating systems', 'chromeOS': new?.operatingSystem === 'Chromebook' }"></em>
              {{getOSName(new?.operatingSystem)}}
            </td>
            <td> {{ new?.deviceCount }}</td>
            <td>
              <div *ngIf=" new.deviceCount > 0" style="width: max-content;">
                <a (click)="viewDevices(new)"
                  [ngClass]="!(new?.packageStatus === 'pending')?'mouse_poniter':'default_pointer'"><em
                    class="send_Icon_img"></em>&nbsp;&nbsp;{{viewDevice}}</a>
              </div>
              <div *ngIf=" new?.deviceCount == 0" [ngbPopover]="popContent2" triggers="mouseenter:mouseleave"
                style="width: max-content;">
                <a class="btn-disabled" disabled="disabled"
                  [ngClass]="!(new?.packageStatus === 'pending')?'mouse_poniter':'default_pointer'"><em
                    class="send_icon_disabled_img"></em>&nbsp;&nbsp;{{viewDevice}}</a>
              </div>
            </td>
          </tr>
          <!-- TODO the below code is part of old design now handling via new design-->
          <!-- <tr *ngIf="!profileData.length">
            <td class="profile_Record" [innerHTML]="noRecordFound"></td>
          </tr> -->
        </tbody>
      </table>
    </div>
    <div class="text-center" *ngIf="!profileData?.length" id="textCenter">
      <span *ngIf='(!isLoading && isProfileDataEmpty); else loading' i18n="@@active-users.expand.no-records-found">No
        Records Found</span>
      <ng-template #loading>
        <div class="text-center">{{isSwitched ? '' : globalConst.LOADING}}</div>
      </ng-template>
    </div>
    <ng-template #popContent2>
      <div class="popover-upload-req" id="popoverUploadReqDiv">
        <div class="d-flex align-items-center" id="odaDiv">
          <span>No devices to show</span>
        </div>
      </div>
    </ng-template>
    <div *ngIf="profileData?.length" class="mt-3 card-footer flex-column align-items-center" id="profileDatacardFooter">
      <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize" [rotate]="false"
        [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false" (pageChange)="onTableDataChange($event)">
      </ngb-pagination>
      <div class="mt-2">
        <span class="page-footer-label" *ngIf="profileData?.length" i18n="@@profile.header.page-count">Showing
          <strong>{{ showFrom }} - {{ showTo }}</strong> of <strong>{{ paginationCount }} Profiles</strong></span>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal-dialog-centered" [ngClass]="isWindows10S ? 'large_size': 'medium_size'" *ngIf="downloadPopup"
  id="modalDialogIsWin10S">
  <div class="modal-backdrop show" id="modalBackDropShow"></div>
  <div class="modal" id="myModal">
    <div class="modal-dialog" id="myModalDialog">
      <div class="modal-content" id="modalContent">
        <div class="close modal_close_icons" data-dismiss="modal" (click)="closePopup()" id="modalCloseIcons"></div>
        <div class="modal-body" id="modalBody">

          <div *ngIf="!isWindows10S" id="isNotWin10S">
            <span class="mt-4" *ngIf="isGamingMessage">{{gamingPackageMsgText}}</span>
            <div class="mt-3" id="pkgDwnldAgainMsg">
              <span>{{packageDwnldAgainMsg}}</span>
              <!-- Commented for fixing 8355 & 8356 -->
              <!-- <span i18n="@@installation-package.download-package.current-installation-text">You can also download the current Installation Package for the <strong>{{profileName}}</strong> Profile again at any time from the detail page, accessible from your Profile list.</span> -->
            </div>
            <div class="downloadable_file_name text-break" id="dwnldFileNameFullPkg">{{fullPkgName}}</div>
          </div>

          <div *ngIf="isWindows10S" id="installProfileTxtIsWin10S">
            <p class="mt-4">{{installationProfileText}}</p>
            <div class="mt-2" id="installPkgWindowsPoint1">
              <span i18n="@@installation-package.download-package.windows-point1">1. If your display devices do not have
                IPOS for Windows* 10 S already installed, please install on these devices: {{uwpDefaultPackage}}</span>
            </div>
            <div class="mt-2" id="installPkgWindowsPoint2"><span
                i18n="@@installation-package.download-package.windows-point2">2. Select the Custom profile option if you
                want to install a Custom package.</span></div>
            <div class='mt-2' id="installPkgWindowsPoint3">
              <span i18n="@@installation-package.download-package.windows-point3-profile">3. You can either enter the
                <strong> Profile ID </strong> (listed below) to proceed or else click on <strong>Choose File </strong>
                to upload the profile content manually (Download or transfer the custom package via USB in order to
                install it on the display device). <div> <strong>Note: </strong> An active internet connection is
                  required for proceeding with Profile ID.</div></span>
            </div>
            <div class="mt-2" id="profileIdDetails"><strong>{{userProfileId}} - {{profileId}}</strong></div>
          </div>

          <div class="button_wrapper" id="btnDwnldPkgName">
            <button class="btn btn-primary btn-lg gtmCreateProfDownloadCurrentPackage" (click)="downloadPackage()">
              {{downloadPackageName}}
            </button>
          </div>

          <div class="form-group mt-4" id="shareURLText">
            <label for="sharePackageLink">{{shareURLText}}</label>:
            <div class="inline_fields" id="sharePkgLink">
              <input class="form-control" readonly id="sharePackageLink" #inputToBeCopied value="{{downloadUrl}}" />
              <button class="btn btn-outline-primary gtmCopyCustomDownloadUrl"
                (click)="copyPackageURL(inputToBeCopied)">{{copyText}}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Generate confirmation popup -->
<iposcen-confirm-dialog #confirmGenModal [popupTitle]="confirmModalTitle" [popupDesc]="confirmModalDesc"
  [popupAction]="confirmModalCTA" [isProfileGenerate]="true"
  (confirm)="confirmGenerateProfile()"></iposcen-confirm-dialog>

<!-- Duplicate profile modal -->
<iposcen-duplicate #duplicateProfile [profileName]="currentProfileName" [profileData]="profileData"
  (duplicate)="createDuplicateProfile($event)"></iposcen-duplicate>
<!-- ends here -->

<!--Generate package-linux os popup-->
<div class="modal-dialog-centered" *ngIf="selectlinuxospackagePopup" id="generatePkgLinuxOsPopup">
  <div class="modal-backdrop show" id="modalGeneratePkgShow"></div>
  <div class="modal" id="myModal">
    <div class="modal-dialog generatePopup" id="myModalDialog">
      <div class="modal-content" id="myModalContent">
        <div class="card" id="modalCard">
          <div class="modal-header" id="modalHeader">
            <div class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSelectPackagePopup()"
              id="inviteSuccessModalCloseIcon"></div>
          </div>
          <div class="modal-body invitesuccess-panel" id="inviteSuccessPanel">
            <div class="invitesuccess-title text-left" id="inviteSuccessTitle">
              {{generatePackageSelectTitle}}
            </div>
            <div class="mt-c3 invitesuccess-content text-center" id="generatePkgSelectLinuxISO">
              <button class="btn-primary btn-lg gtmCreateProfDownloadPackage" (click)="onGenerateLinuxISO()">
                {{generatePackageSelectLinuxiso}}
              </button>
            </div>
            <div class="mt-c3 invitesuccess-content text-center" id="inviteSuccessConTxtCenter">
              <button class="btn-primary btn-lg gtmCreateProfDownloadPackage" (click)="onGenerateLinuxIPOS()">
                {{generatePackageSelectLinuxipos}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-dialog-centered" *ngIf="generatepackageprogressPopup" id="generatePkgProgressPopup">
  <div class="modal-backdrop show" id="modalBackdropPkgProgress"></div>
  <div class="modal" id="myModal">
    <div class="modal-dialog generatePopup" id="myModalGeneratePopup">
      <div class="modal-content" id="myModalContent">
        <div class="card" id="myModalCard">
          <div class="modal-header" id="myModalHeader">
            <div class="invitesuccessmodal-close-icon" data-dismiss="modal"
              (click)="onCloseGeneratePackageProgressPopup()" id="myModalPkgProgressPopup"></div>
          </div>
          <div class="modal-body invitesuccess-panel" id="myModalBodyPanel">
            <div class="invitesuccess-title" id="inviteSuccessTitle">
              {{generatePackageProgressTitle}}
            </div>
            <div class="invitesuccess-content text-center aligncenter" id="inviteSuccessContent">
              {{generatePackageProgressContent}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"
  (getStatus)='isLoading = $event'></iposcen-spinner-overlay>
<iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false"
  (getStatus)='isLoading = $event'></iposcen-spinner-overlay>